import { authenticatedRestClient } from 'helpers/restclient';
import { SORT_DIR } from 'store/slices/bulkEdit/constants';

const SELLERS_API_PREFIX = '/api/sellers';

export default class BulkEditService {
	static instance = new BulkEditService();

	_endpoints = {
		bulkVehicles: `${SELLERS_API_PREFIX}/bulk_vehicles`,
	};

	constructor() {
		this.authenticatedRestClient = authenticatedRestClient;
	}

	buildBulkVehiclesParams = (config = {}) => {
		const { page, per_page, filters = {}, sort = {} } = config;

		const flagParams = (source, mappings) =>
			Object.entries(mappings).reduce((acc, [key, paramKey]) => {
				if (source?.[key]) acc[paramKey] = true;
				return acc;
			}, {});

		const sortParams = flagParams(sort, {
			order_by_most_recent_activity: 'order_by_most_recent_activity',
			order_by_price: 'order_by_price',
			order_by_starting_bid_amount: 'order_by_starting_bid_amount',
		});

		return {
			auction: true,
			page: page || 1,
			...(per_page ? { per_page } : {}),
			...(filters.keywords ? { keywords: filters.keywords } : {}),
			...flagParams(filters, {
				strongOffers: 'has_strong_offer',
				newOffers: 'has_new_offer',
			}),
			...sortParams,
			...(Object.keys(sortParams).length ? { direction: sort.direction || SORT_DIR.DESC } : {}),
		};
	};

	getBulkVehicles = (config = {}) => {
		return this.authenticatedRestClient.get(this._endpoints.bulkVehicles, this.buildBulkVehiclesParams(config));
	};

	getBulkVehiclesMetadata = (config = {}) => {
		return this.authenticatedRestClient.get(this._endpoints.bulkVehicles, {
			...this.buildBulkVehiclesParams(config),
			metadata_only: true,
		});
	};

	updateBulkVehicles = (vehicles = []) => {
		const payload = { vehicles };
		return this.authenticatedRestClient.put(this._endpoints.bulkVehicles, payload);
	};
}
